import React from 'react';

export const consolidatedEwCreatorTableConfig = {
  columns: [
    {
      Header: 'Date & Time',
      headerClassName: 'flex-15',
      accessor: 'dateTime',
      className: 'flex-15'
    },
    {
      Header: 'Created By',
      headerClassName: 'flex-12',
      accessor: 'createdByUser',
      className: 'flex-12'
    },
    {
      Header: 'Vehicle Number',
      headerClassName: 'flex-12',
      accessor: 'vehicleNumber',
      className: 'flex-12'
    },
    {
      Header: 'CN Count',
      headerClassName: 'flex-10',
      accessor: 'cnCount',
      className: 'flex-10'
    },
    {
      Header: 'List of CNs',
      headerClassName: 'flex-12',
      accessor: 'cnotes',
      className: 'flex-12',
      Cell: obj => (
        <button
          onClick={() => {
            if (
              consolidatedEwCreatorActionConfig.actions &&
              consolidatedEwCreatorActionConfig.actions.downloadCns
            ) {
              consolidatedEwCreatorActionConfig.actions.downloadCns(
                obj.original
              );
            }
          }}
          style={{
            background: 'none',
            border: 'none',
            color: '#007bff',
            cursor: 'pointer',
            textDecoration: 'underline',
            fontSize: '12px',
            fontWeight: 600,
            padding: 0
          }}
        >
          Download CNs
        </button>
      )
    },
    {
      Header: 'Status',
      headerClassName: 'flex-25',
      accessor: 'status',
      className: 'flex-25',
      Cell: obj => {
        const status = obj?.original?.status;

        if (!status) {
          return <div title="Status Not Available">-</div>;
        }

        const getStatusStyle = statusValue => {
          if (statusValue === 'Success') {
            return { color: 'green', fontWeight: 'bold' };
          }
          if (statusValue.includes('Failed')) {
            return null;
          }
          return { color: 'orange', fontWeight: 'bold' };
        };

        const renderFailedStatus = statusValue => {
          const remainingText = statusValue.replace('Failed', '');
          return (
            <div
              title={statusValue}
              style={{ color: '#444444', cursor: 'pointer' }}
            >
              <span style={{ color: '#de1313', fontWeight: 'bold' }}>
                Failed
              </span>
              <span style={{ fontSize: '13px' }}>{remainingText}</span>
            </div>
          );
        };

        if (status.includes('Failed')) {
          return renderFailedStatus(status);
        }

        const statusStyle = getStatusStyle(status);
        return (
          <div title={status} style={statusStyle}>
            {status}
          </div>
        );
      }
    },
    {
      Header: 'Consolidated EWB',
      headerClassName: 'flex-15',
      accessor: 'cewbNumber',
      className: 'flex-15'
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No data found',
  minRows: 7,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 21rem)' }
};

export const consolidatedEwCreatorActionConfig = {
  buttons: []
};

export const cewbTemplateDownloadHeaders = [
  { key: 'cnote', Header: 'cnote' },
  { key: 'vehicleNumber', Header: 'vehicleNumber' }
];
